// extracted by mini-css-extract-plugin
export default {"border":"TipBox_border__F9K6p"};